import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import CollectorLoginPage from "./Login/CollectorLoginPage/CollectorLoginPage";
import Dashboardcolpagesss from "./Dashboard/Dashboardcolpagesss/Dashboardcolpagesss";
import CollectorForgetPassword from "./Login/CollectorLoginPage/CollectorForgetPassword/CollectorForgetPassword";
import VoiceRecorderPage from "./SpeechRecognitionpage/SpeechRecognitionpage";
import Reportcolpagesss from "./Dashboard/Dashboardcolpagesss/Reportcolpagesss/Reportcolpagesss";
import ProfileColPagesss from "./Dashboard/Dashboardcolpagesss/ProfileColPagesss/ProfileColPagesss";


import { initialComplaintsData } from "./data/mockData";
import { api } from "./services/api";
// import { ToastContainer } from "react-toastify";

import "./App.css";
import "./Login/CollectorLoginPage/widget";
import DistrictMap from "./Dashboard/Dashboardcolpagesss/Heatmapcolpagesss/DistrictMap/DistrictMap";
import Notification from "./Dashboard/Dashboardcolpagesss/Heatmapcolpagesss/Notification/Notification";
import PrivateRoute from "./components/PrivateRoute";
import Overviewcolpagesss from "./Dashboard/Dashboardcolpagesss/Overviewcolpagesss/Overviewcolpagesss";
import BlockFeedbackPage from "./Dashboard/BlockFeedbackPage/BlockFeedbackPage";
import FeedbackListPage from "./Dashboard/FeedbackListPage/FeedbackListPage";
import PasswordPagesss from "./Dashboard/Dashboardcolpagesss/PasswordPagesss/PasswordPagesss";
import MainPage from "./mainpage/mainpage";

function App() {
  const [notifications, setNotifications] = useState([]);
  const [complaintsData, setComplaintsData] = useState(initialComplaintsData);
  const subscriptionRef = useRef(null);

  const addNotification = (message, block = null) => {
    const newNotification = {
      id: Date.now(),
      message,
      timestamp: new Date().toLocaleTimeString(),
      block,
    };

    setNotifications((prev) => [newNotification, ...prev.slice(0, 4)]);

    setTimeout(() => {
      setNotifications((prev) => prev.filter((notif) => notif.id !== newNotification.id));
    }, 5000);
  };

  const handleNewComplaint = (message, block) => {
    if (block && complaintsData[block.toLowerCase()] !== undefined) {
      setComplaintsData((prev) => ({
        ...prev,
        [block.toLowerCase()]: prev[block.toLowerCase()] + 1,
      }));
    }

    addNotification(message, block);
  };

  // Real-time subscription
  // useEffect(() => {
  //   subscriptionRef.current = api.subscribeToNotifications(handleNewComplaint);

  //   return () => {
  //     if (subscriptionRef.current) {
  //       api.unsubscribeFromNotifications(subscriptionRef.current);
  //     }
  //   };
  // }, []);

  // Initial data load
  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     try {
  //       const response = await api.getComplaints();
  //       setComplaintsData(response.data);
  //     } catch (error) {
  //       // console.log("Using mock data for development");
  //       setComplaintsData(initialComplaintsData);
  //     }
  //   };

  //   fetchInitialData();
  // }, []);

  // Initialize the chatbot widget once the app loads.
  useEffect(() => {
    const mountWidget = () => {
      const hasRoot = document.getElementById("rag-widget-root");
      const hasContainer = document.getElementById("rag-widget-mount");

      if (window.RAG_WIDGET?.init && !hasRoot && hasContainer) {
        window.RAG_WIDGET.init({ containerId: "rag-widget-mount" });
      }
    };

    mountWidget();
    const retry = setTimeout(mountWidget, 300);

    return () => clearTimeout(retry);
  }, []);

 return (
  <>
    {/* <ToastContainer position="top-right" autoClose={3000} /> */}
    <Router>
      <Routes>
       <Route path="/" element={<MainPage/>}/>
        <Route path="/collectorLoginPage" element={<CollectorLoginPage />} />
        <Route path="/collectorForgetPassword" element={<CollectorForgetPassword />} />
        <Route path="/voiceRecorderPage" element={<VoiceRecorderPage />} />
        <Route path="/reportcolpagesss" element={<Reportcolpagesss />} />
        <Route path="/profileColPagesss" element={<ProfileColPagesss />} />
         {/* <Route path="/blockFeedbackPage" element={<BlockFeedbackPage/>} /> */}
          {/* <Route path="/feedback-list" element={<FeedbackListPage/>} /> */}
          <Route path="/passwordPagesss" element={<PasswordPagesss/>} />

        {/* Protected routes grouped under PrivateRoute */}
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboardcolpagesss />} />
          <Route path="/overviewcolpagesss" element={<Overviewcolpagesss />}/>
          
          {/* add other protected routes here if needed */}
        </Route>

        <Route
          path="/crime-dashboard"
          element={
            <div className="App">
              <div className="app-grid">
                {/* LEFT – Crime Stats */}
                <div className="dashboard-panel">
                  <div className="stats-container">
                    <div className="block-stats"></div>
                  </div>
                </div>

                {/* RIGHT – Map */}
                <div className="map-panel">
                  <Notification notifications={notifications} />

                  <DistrictMap
                    complaintsData={complaintsData}
                    setComplaintsData={setComplaintsData}
                    addNotification={addNotification}
                  />
                </div>
              </div>
            </div>
          }
        />
      </Routes>
    </Router>
    </>
  );
}

export default App;
